<template scroll="no" style="overflow :initial">
	<div scroll="no"
		style="overflow :initial;position: relative;min-height:100vh;width: 100%;background-color: #fff;padding-bottom: 4vh;">

		<div style="padding-top: 4vh;padding-left: 20%;">
			<el-form :model="query" :rules="rules" ref="queryForm" :inline="true" size="mini">
				<el-form-item label="快递公司" prop="cpCode">
					<el-select v-model="query.cpCode" filterable placeholder="请选择快递公司" style="width: 100%;">
						<el-option v-for="i in cp_list" :label="i.label" :value="i.value" :key="i"> </el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="运单号" prop="waybillNo">
					<el-input placeholder="请输入运单号码" v-model="query.waybillNo" clearable></el-input>
				</el-form-item>
				<el-checkbox v-model="query.showIndirect">显示间接操作</el-checkbox>
				<el-checkbox v-model="query.reverseOrder">倒序</el-checkbox>
				<el-form-item style="margin-left: 2%;">
					<el-button type="primary" :loading="query_loading" icon="el-icon-search"
						@click="clickQuery(query.cpCode,query.waybillNo,query.showIndirect,query.reverseOrder)">查询</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div scroll="no" v-if="showData">
			<!--圆通-->
			<div v-if="YTO_show">
				<div class="info">
					<table border="1" style="border: 1px solid #e8e8e8;">
						<tr>
							<th>快递公司</th>
							<td>圆通快递</td>
							<th>运单号</th>
							<td>{{waybillInfo.waybillNo}}</td>
							<th>类型</th>
							<td>{{waybillInfo.expressContentName}}</td>
							<th>最新状态</th>
							<td v-if="waybillInfo.statusName">{{waybillInfo.statusName}}</td>
							<td v-else>未发出</td>
							<th>面单类型</th>
							<td>{{customerInfo.materialName}}</td>
						</tr>
						<tr>
							<th>VIP标识</th>
							<td v-if="customerInfo.isVip == 1">是</td>
							<td v-else>否</td>
							<th>航空件标识</th>
							<td v-if="customerInfo.isHKJ == 1">是</td>
							<td v-else>否</td>
							<th>客户类型</th>
							<td v-if="customerInfo.customerType == 'DSKH'">电商</td>
							<td v-else>{{customerInfo.customerType}}</td>
							<th>客户名称</th>
							<td>{{customerInfo.customerName +'-'+ customerInfo.customerCode}}</td>
							<th>店铺名称</th>
							<td>{{customerInfo.sellerName  +'-'+ customerInfo.sellerId }}</td>
						</tr>
						<tr>
							<th>订单号</th>
							<td>{{waybillInfo.orderNo}}</td>
							<th>创建时间</th>
							<td>{{customerInfo.subscribeTime}}</td>
							<th>最新操作时间</th>
							<td>{{waybillInfo.lastOpTime}}</td>
							<th>三段码</th>
							<td colspan="2">{{customerInfo.daTouBi}}</td>
						</tr>
						<tr>
							<th>发件信息</th>
							<td colspan="3">
								{{waybillInfo.senderName}}&#8194;{{waybillInfo.senderTel}}&#8194;{{waybillInfo.senderProvName}}{{waybillInfo.senderCityName}}{{waybillInfo.senderTownName}}{{waybillInfo.senderDetailAddress}}
							</td>
							<th>始发网点</th>
							<td colspan="1">{{waybillInfo.sourceOrgName}}</td>
							<th>揽件员</th>
							<!-- <td colspan="2">{{waybillInfo.takingEmpName}}-{{waybillInfo.takingEmpCode}}</td> -->
							<td v-if="waybillInfo.takingEmpName!='符琴'" colspan="2">{{waybillInfo.takingEmpName}}</td>
							<td v-else>-</td>
						</tr>
						<tr>
							<th>收件信息</th>
							<td colspan="3">
								{{waybillInfo.receiverName}}&#8194;{{"*"}}&#8194;{{waybillInfo.desProvName}}{{waybillInfo.desCityName}}{{waybillInfo.desCountryName}}{{waybillInfo.receiverDetailAddress}}
							</td>
							<th>派件网点</th>
							<td colspan="1">{{waybillInfo.desOrgName}}</td>
							<th>派件员</th>
							<td colspan="2">{{waybillInfo.deliveryEmpName}}-{{waybillInfo.deliveryEmpCode}}</td>
						</tr>
					</table>
				</div>
				<div style="position: relative;top: 2rem;">
					<el-table :data="query.showIndirect ? data : data.filter((item) => item.isDirect=='1')" border
						:stripe="true" :default-sort="{prop: 'opTime', order: 'descending'}">
						<el-table-column prop="opTime" label="操作时间" sortable width="90">
							<template #default="scope">
								<div>{{ scope.row.opTime.slice(0,10)}}</div>
								<div>{{ scope.row.opTime.slice(11,18)}}</div>
							</template>
						</el-table-column>
						<el-table-column prop="opOrgName" label="操作组织" min-width="90"></el-table-column>
						<el-table-column prop="opEmpName" label="操作人员">
							<template #default="scope">
								<div v-if="scope.row.opEmpName">
									操作员：{{suffix_processing(scope.row.opEmpName)["opEmpName"]}}</div>
								<div v-if="scope.row.empName">业务员：{{suffix_processing(scope.row.empName)["empName"]}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="opName" label="操作类型"></el-table-column>
						<el-table-column prop="nextOrgName" label="下一组织"></el-table-column>
						<el-table-column prop="ioTypeName" label="状态" align="center"></el-table-column>
						<el-table-column label="操作信息" prop="orderInfo" align="center" min-width="120">
							<template #default="scope">
								<el-popover v-if="scope.row.orderInfo && scope.row.orderInfo.length>25"
									placement="top-start" trigger="hover">
									<div>{{scope.row.orderInfo}}</div>
									<template #reference>
										<div>
											<span>{{ scope.row.orderInfo.slice(0,25)}}</span>
											<span> ...</span>
										</div>
									</template>

								</el-popover>
								<div v-else>{{scope.row.orderInfo}}</div>
								<div v-if="scope.row.newWaybillNo">换单号：{{scope.row.newWaybillNo}}</div>
								<div v-if="scope.row.deliveryFailReason">{{scope.row.deliveryFailReason}}</div>
							</template>
						</el-table-column>
						<el-table-column prop="containerNo" label="容器" align="center">
							<template #default="scope">
								<a :href="'/queryWaybill?cpCode='+query.cpCode+'&'+'waybillNo='+scope.row.containerNo"
									target="_blank" v-if="scope.row.containerNo"
									style="text-decoration: none;color: #409eff;">{{scope.row.containerNo}}</a>
							</template>
						</el-table-column>
						<el-table-column prop="weight" label="重量">
							<template #default="scope">
								<div
									v-if="scope.row.weighWeight && scope.row.weighWeight!='0.0'&& scope.row.weighWeight!='0'">
									称入重：{{scope.row.weighWeight}}</div>
								<div
									v-if="scope.row.volumeWeight && scope.row.volumeWeight!='0.0'&& scope.row.volumeWeight!='0'">
									体积重：{{scope.row.volumeWeight}}</div>
								<div
									v-if="scope.row.inputWeight && scope.row.inputWeight!='0.0'&& scope.row.inputWeight!='0'">
									输入重：{{scope.row.inputWeight}}</div>
									
								<div v-if="scope.row.pkgLength && scope.row.pkgLength!='0.0' && scope.row.pkgWidth!='0.0' && scope.row.pkgHeight!='0.0'">
									体积：{{scope.row.pkgLength + '*'+scope.row.pkgWidth + '*'+scope.row.pkgHeight}}</div>
							</template>
						</el-table-column>
						<el-table-column prop="effectiveTypeName" label="时效" align="center"
							width="80"></el-table-column>
						<el-table-column prop="deviceType" label="操作端">
							<template #default="scope">
								<div>{{toYT_deviceName(scope.row.deviceType)}}</div>
								<div>{{suffix_processing(scope.row.opEmpName)["suffixName"]}}</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<!--异常操作-->
				<div style="position: relative;margin: 3rem 0;">
					<div style="margin: 10px;color: #838383;">异常操作</div>
					<el-table :data="abnormal_operation" border>
						<el-table-column prop="operateTime" label="日期" width="70"></el-table-column>
						<el-table-column prop="waybillNum" label="运单号" width="100"></el-table-column>
						<el-table-column prop="operateNetwork" label="操作组织" width="100"></el-table-column>
						<el-table-column prop="operator" label="操作员" width="100"></el-table-column>
						<el-table-column prop="operate" label="操作类型" width="100"></el-table-column>
						<el-table-column prop="nextNetwork" label="下一组织"></el-table-column>
						<el-table-column prop="exceptionDescription" label="异常描述"></el-table-column>
						<el-table-column prop="weigh" label="重量"></el-table-column>
					</el-table>
				</div>
				<!--工单-->
				<!-- <div style="position: relative;margin-top: 11vh;">
					<el-table size="mini" style="font-size: 0.55rem" border>
						<el-table-column prop="nextNetwork" label="创建时间"></el-table-column>
						<el-table-column prop="nextNetwork" label="运单号"></el-table-column>
						<el-table-column prop="operateTime" label="工单类型" width="180"></el-table-column>
						<el-table-column prop="operateNetwork" label="状态"></el-table-column>
						<el-table-column prop="operator" label="创建人"></el-table-column>
						<el-table-column prop="operate" label="来源"></el-table-column>
						<el-table-column prop="nextNetwork" label="处理结果"></el-table-column>
					</el-table>
				</div> -->
			</div>
			<!--申通-->
			<div style="position: relative;top: 3em;width: 100%;" v-show="STO_show">
				<el-table :data="data" border size="mini" style="width: 100%"
					:default-sort="{prop: 'opTime', order: 'descending'}">
					<!-- <el-table-column prop="waybillNo" label="运单号" width="120"></el-table-column> -->
					<el-table-column prop="opTime" label="操作时间" width="90" sortable></el-table-column>
					<el-table-column prop="opOrgName" label="操作组织" width="180">
						<template #default="scope">
							<span>{{scope.row.opOrgName}}({{scope.row.opOrgCode}})</span>
						</template>
					</el-table-column>
					<el-table-column prop="opEmpName" label="操作人员" align="center" width="200">
						<template #default="scope">
							<div v-if="scope.row.opEmpName">扫描员：{{scope.row.opEmpName}}({{scope.row.opEmpCode}})</div>
							<div v-if="scope.row.bizEmpName">
								<span>业务员：{{scope.row.bizEmpName}}</span>
								<span v-if="scope.row.bizEmpCode">({{scope.row.bizEmpCode}})</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="scanType" label="操作类型" align="center" width="80"></el-table-column>
					<el-table-column prop="nextOrgName" label="下一组织" align="center" width="120"></el-table-column>
					<el-table-column prop="weight" label="重量" align="center" width="80">
						<template #default="scope">
							<div v-if="scope.row.weight && scope.row.weight!='0' && scope.row.weight!='0.0'">
								<span>{{scope.row.weight}}</span>
								<span>公斤</span>
							</div>
							<div v-else>
								<span></span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="memo" align="center" label="描述">
						<template #default="scope">
							<el-popover placement="top-start" title="" trigger="hover">
								<div style="width: 12rem;height: auto;">{{scope.row.memo}}</div>
								<template #reference>
									<span>{{ scope.row.memo.slice(0,50)}}</span>
								</template>
							</el-popover>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<!-- 极兔 -->
			<div style="position: relative;top: 3em;width: 100%;" v-show="JT_show">
				<el-table :data="data" border size="mini" style="width: 100%"
					:default-sort="{prop: 'scanTime', order: 'descending'}">
					<!-- <el-table-column prop="waybillNo" label="运单号" width="150"></el-table-column> -->
					<el-table-column prop="scanTime" label="操作时间" align="center" width="90" sortable></el-table-column>
					<el-table-column prop="scanNetworkName" align="center" label="操作组织" width="160">
						<template #default="scope">
							<span>{{scope.row.scanNetworkName}}({{scope.row.scanNetworkId}})</span>
						</template>
					</el-table-column>
					<el-table-column prop="scanNetworkTypeName" align="center" label="组织类型"
						width="90"></el-table-column>
					<!-- <el-table-column prop="opEmpName" label="操作员" width="90"></el-table-column> -->
					<el-table-column prop="staffName" label="业务员" align="center" width="90"></el-table-column>
					<el-table-column prop="scanType" label="操作类型" align="center" width="90"></el-table-column>
					<el-table-column prop="problemType" label="异常类型" align="center" width="90"></el-table-column>
					<el-table-column prop="scanNetworkName" label="下一组织" align="center" width="160">
						<template #default="scope">
							<span>{{scope.row.nextStopName}}{{scope.row.nextNetworkId}}</span>
						</template>

					</el-table-column>
					<!-- <el-table-column prop="weight" label="重量" width="80"></el-table-column> -->
					<el-table-column prop="remark" label="备注" align="center" width="90"></el-table-column>
					<el-table-column prop="desc" align="center" label="描述">
						<template #default="scope">
							<el-popover placement="top-start" title="" trigger="hover">
								<div style="width: 10rem;height: auto;">{{scope.row.desc}}</div>
								<template #reference>
									<span>{{ scope.row.desc.slice(0,70)}}</span>
								</template>
							</el-popover>
						</template>
					</el-table-column>
				</el-table>
			</div>

		</div>
	</div>
</template>

<script>
	// import watermark from '../../module/watermark.js'
	export default {
		data() {
			return {
				customerInfo: {},
				waybillInfo: {},
				showData: false,
				data: [], //千万不要填{}，否则element表格行不会自动占满剩余空间
				abnormal_operation: [],
				YTO_show: false,
				query: {
					cpCode: '',
					waybillNo: '',
					showIndirect: true,
					reverseOrder: false
				},
				cp_list: [{
						label: '圆通速递',
						value: 'YTO'
					}, {
						label: '申通快递',
						value: 'STO'
					}
					/* ,{
										label: '极兔速递',
										value: 'JT'
									} */
				],
				rules: { //名称要和query的名称一致，不然校验不通过
					cpCode: [{
						required: true,
						message: '请选择快递公司',
						trigger: 'change'
					}],
					waybillNo: [{
							required: true,
							message: '请输入运单号码',
							trigger: 'change'
						},
						{
							min: 8,
							max: 25,
							message: '请输入正确的运单号',
							trigger: 'change'
						}
					]
				},
				query_loading: false,
				STO_show: false,
				JT_show: false
			}
		},
		methods: {
			clickQuery(cpCode, waybillNo, showIndirect, reverseOrder) {
				console.log(cpCode, waybillNo, showIndirect, reverseOrder)
				this.$router.replace({
					path: '/queryWaybill',
					query: {
						cpCode: cpCode,
						waybillNo: waybillNo,
						showIndirect: showIndirect,
						reverseOrder: reverseOrder
					}
				}).then(() => {
					location.reload();
				});
			},
			getRoute(cpCode, waybillNo) {
				this.$refs['queryForm'].validate((valid) => {
					if (valid) {
						this.showData = false;
						this.data = [];
						const loading = this.$loading({
							lock: true,
							text: '加载中...',
							spinner: 'el-icon-loading',
							background: 'rgba(109, 109, 109, 0.7)'
						});
						// setTimeout(() => {loading.close();}, 6000);
						this.apiService.post({
								modules: "InternalWaybill",
								content: {
									cpCode: cpCode,
									waybillNo: waybillNo
								}
							})
							.then((res) => {
								//成功
								if (res.status) {
									this.data = res.data.track //走件
									if (cpCode == "YTO") {
										this.abnormal_operation = res.data.abnormal //异常操作
										this.customerInfo = res.data.customerInfo //客户信息
										this.waybillInfo = res.data.waybillInfo //运单信息
										console.log(this.data)
										this.YTO_show = true
									} else {
										this.YTO_show = false
									}
									if (cpCode == "STO") {
										this.STO_show = true
									} else {
										this.STO_show = false
									}
									if (cpCode == "JT") {
										this.JT_show = true
									} else {
										this.JT_show = false
									}
									this.showData = true;
								} else {
									this.$message({
										showClose: true,
										message: '错误：' + res.msg,
										type: 'error'
									});
								}
								loading.close();
							})
							.finally(() => {
								loading.close();
							})
					} else {
						console.log('内容未输入完整');
						this.$message.error('存在必填内容未填');
						return false;
					}
				});
			},
			toYT_deviceName(typeCode) {
				//操作终端编码转换
				const deviceCode = {
					'PDA-N': '尊者APP',
					'PC-N': '尊者PC',
					'CV-APP': '条码威视APP',
					'CV-PC': '条码威视PC',
					'CV-PDA': '业务网关',
					'CV-OTHER': '其他终端',
					'终端第三方': '第三方终端', //第三方快递柜\驿站
					'YM': '运盟',
					'YM-APP': '运盟APP',
					'XZ-IOS': '行者-IOS',
					'XZ-AND': '行者-安卓',
					'YZ-AND': '妈妈驿站-安卓',
					'YZ-IOS': '妈妈驿站-IOS',
					'YZ-ZS': '妈妈驿站-其他',
					'YZ-XPC': '妈妈驿站-新WEB',
					'YZ-AUT': '妈妈驿站-一体机',
					'WDGJ-PC': '网点管家-PC',
					'WDGJ-APP': '网点管家-APP',
					'SHARE-PROJECT': '共配终端',
					'share_platform': '共配平台',
					'PC': '子系统',
					'PDA': 'PDA',
					'PDA-FO': '尊者APP前置操作',
					'PC-HD': '换单退回',
					'JG': '金刚系统'
				}
				var typeName = typeCode;
				try {
					typeName = deviceCode[typeCode];
				} catch (e) {
					//TODO handle the exception
				}
				return typeName
			},
			suffix_processing(name) {
				var re = /([\u4e00-\u9fa5]*-([a-zA-Z]|[0-9])*)|[\u4e00-\u9fa5](（[\u4e00-\u9fa5]）*)/;
				if (re.test(name)) {
					var suffix = name.match(/(-([a-zA-Z]|[0-9])*)|(（[\u4e00-\u9fa5]）*)/)[0]
					//操作终端编码转换
					const suffixCode = {
						'-D': '上车带下车',
						'-Z': '揽发合一',
						'-L': '一键上车',
						'-T': '一键揽/取',
						// '-H': '一键派件',
						'-F': '前置操作',
						// '-Z': '合一操作',
						'-P': '无单称重',
						'-O': '不称重揽收',
						'-A': '下车带出揽收',
						'-(代)': '下车带出揽收',
						'（代）': '下车带出揽收',
						'-CC': '主数据业务员',
						'-H': '合并操作',
						'-Q': '全流程',
						'-Y': '延迟派件',
						'-XC': '取下车',
						'-PJ': '取派件',
						'-SC': '取站点绑定',
						'-3C': '取三段码',
						'-V': '大客户、容器揽收',
						'-R': '标准自动化',
						'-E': '第三方设备',
						'-B': '批量入库',
						'-f': '安心派件',
						'-S': '驿站混扫',
						'-N': '简易驿站',
						'-A代': '二级仓下车带揽收'
					}
					var suffixName = "";
					var empName = "";
					var opEmpName = "";
					try {
						if (!/-[0-1]{1,4}/.test(suffix)) {
							suffixName = suffixCode[suffix];
						} else {
							var empSuffixCode = String(suffix.slice(1, 5))
							if (empSuffixCode[0] == '1') {
								suffixName.concat('重量锁定')
							}
							if (empSuffixCode[1] == '1') {
								suffixName.concat('目的网点锁定/')
							}
							if (empSuffixCode[2] == '1') {
								suffixName.concat('收派员锁定/')
							}
							if (empSuffixCode[3] == '1') {
								suffixName.concat('关闭建包规则/')
							}
						}
						empName = name.replace(suffix, "")
						opEmpName = name.replace(suffix, "")
					} catch (e) {
						suffixName = suffixCode;
						empName = name
						opEmpName = name
					}
					return {
						"empName": empName,
						"opEmpName": opEmpName,
						"suffixName": suffixName
					}
				} else {
					return {
						"empName": name,
						"opEmpName": name,
						"suffixName": ""
					}
				}
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
		},
		created() {
			// var userInfo = JSON.parse(localStorage.getItem('userInfo'));
			// watermark.set(userInfo.userId + '' + String(Date.now()).slice(5, 10) + '禁止截图')
		},
		watch: {
			'$route': function(to, from) {
				console.log(to, from)
				let cpCode = this.$route.query.cpCode;
				let waybillNo = this.$route.query.waybillNo;
				let showIndirect = this.$route.query.showIndirect;
				let reverseOrder = this.$route.query.reverseOrder;
				if (cpCode && waybillNo) {
					this.query.cpCode = cpCode;
					this.query.waybillNo = waybillNo;
					this.query.showIndirect = Boolean(showIndirect);
					this.query.reverseOrder = Boolean(reverseOrder);
					this.getRoute(cpCode, waybillNo, showIndirect, reverseOrder);
				} else {
					console.log('条码不存在', waybillNo)
				}
			} /* , */
			/* 'query.reverseOrder': {
				handler(newVal, oldVal) {
			        console.log(newVal)
					var trask = this.data.reverseOrder()
					this.data = trask
					this.$forceUpdate()
			    },
			    immediate: true
			} */
		},
		mounted() {
			let cpCode = this.$route.query.cpCode;
			let waybillNo = this.$route.query.waybillNo;
			let showIndirect = this.$route.query.showIndirect;
			let reverseOrder = this.$route.query.reverseOrder;
			if (cpCode && waybillNo) {
				this.query.cpCode = cpCode;
				this.query.waybillNo = waybillNo;
				this.query.showIndirect = Boolean(showIndirect);
				this.query.reverseOrder = Boolean(reverseOrder);
				this.getRoute(cpCode, waybillNo, showIndirect, reverseOrder);
			} else {
				console.log('条码不存在', waybillNo)
			}
		}
	}
</script>

<style scoped>
	.info {
		top: 2vh;
		position: relative;
	}

	.info table {
		border: none;
		border-collapse: collapse;
		/*合并单元格边框*/
		width: 100%;
		text-align: center;
		/*居中*/
	}

	.info th,
	td {
		border: none;
		/*去除默认边框*/
	}

	.info td {
		padding: 0.4rem;
	}

	.info tr {
		padding: 0.1rem 0rem 0.1rem 0rem;
		border-bottom: 1px solid #f3f3f3;
	}

	.info th {
		background: #f7f8f8;
		font-weight: normal;
	}


	.el-input__inner {
		text-align: center;
	}

	/*修改element表格大小*/
	/deep/ .el-table--mini .el-table__cell {
		padding: 2px 0 !important;
	}
</style>